import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'mom-form-field-phone',
  templateUrl: 'form-field-phone.component.html',
  styleUrls: ['./form-field-phone.component.scss']
})
export class FormFieldPhoneComponent {
  @Input() phoneCodeCtrl: FormControl;
  @Input() formCtrl: FormControl;
  @Input() label: string;
  @Input() countries: Option<string>[];
  @Input() required: boolean;
}
